<ion-card>
    <div class="overcard-title">
      JAARLIJKSE KOSTEN
    </div>
    <ion-grid>
      <ion-row>
        <ion-col size="12">
          <canvas baseChart height="300" #yearly="base-chart"
                  [datasets]="barChartData"
                  [labels]="barChartLabels"
                  [colors]="barChartColors"
                  [options]="barChartOptions"
                  [plugins]="barChartPlugins"
                  [legend]="barChartLegend"
                  [chartType]="barChartType">
          </canvas>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card>
